import Offcanvas from '@scripts/modules/Offcanvas';

const getInTouchPopup = new Offcanvas ({
	selector: '#get_in_touch',
    close: '#get_in_touch .close',
    open: '.o_form',
    overlay: '#get_in_touch .ov_offcanvas_center',
    hasForm: true
})

export {
    getInTouchPopup
}